// Share button: uses the device share sheet where available, otherwise copies the link
// and announces "Link copied" through the element's live region.
class SShare extends HTMLElement {
  #timer;

  connectedCallback() {
    this.querySelector('button')?.addEventListener('click', () => this.#share());
  }

  disconnectedCallback() {
    clearTimeout(this.#timer);
  }

  async #share() {
    const url = this.dataset.url || window.location.href;
    const title = this.dataset.title || document.title;

    if (navigator.share) {
      try {
        await navigator.share({ title, url });
      } catch {
        // Closing the share sheet is not an error worth surfacing.
      }
      return;
    }

    try {
      await navigator.clipboard.writeText(url);
      const status = this.querySelector('[data-share-status]');
      if (!status) return;
      status.textContent = this.dataset.copiedMessage || '';
      clearTimeout(this.#timer);
      this.#timer = setTimeout(() => { status.textContent = ''; }, 2500);
    } catch {
      window.prompt(this.dataset.copiedMessage || '', url);
    }
  }
}

if (!customElements.get('s-share')) customElements.define('s-share', SShare);
